
if (typeof Function.prototype.bind === 'undefined') {
  Function.prototype.bind = function (context) {
    var params = ([]).slice.call(arguments, 1);
    var fn = this;
    return function () {
      var allParams = params.concat(([]).slice.call(arguments, 0));
      return fn.apply(context, allParams);
    };
  };
};
module.exports = function anonymous(locals, escape, include, rethrow
/*``*/) {
escape = escape || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"videofail\" id=\"js_video_fail\">\n    <div class=\"videofailLayout\">\n        <div class=\"videofailText\">亲，播放失败了</div>\n        <div class=\"videofailReplay\">\n            <div class=\"videofailReplayBtn\" id=\"js_videofail_replay\">\n                <i></i>\n                <span>重播</span>\n            </div>\n        </div>\n    </div>\n</div>")
  }
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./components/f.component.video.pc/app/modules/error/main.ejs
// module id = bS4S
// module chunks = 0